import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './ProductDetail.css';

const ProductDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, [slug]);

  const fetchProduct = async () => {
    try {
      const response = await fetch(`http://localhost:5000/api/products/${slug}`);
      if (response.ok) {
        const data = await response.json();
        setProduct(data);
        setSelectedImage(data.image);
      } else {
        navigate('/products');
      }
    } catch (error) {
      console.error('Failed to fetch product:', error);
      navigate('/products');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="product-detail-page">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (!product) {
    return null;
  }

  const allImages = [product.image, ...(product.images || [])].filter(Boolean);

  return (
    <div className="product-detail-page">
      <Link to="/products" className="back-link">
        ← Back to Products
      </Link>

      <div className="product-detail-container">
        <div className="product-gallery">
          <div className="main-image">
            <img src={selectedImage || product.image} alt={product.name} />
            {product.featured && (
              <span className="featured-badge">Featured</span>
            )}
          </div>
          
          {allImages.length > 1 && (
            <div className="thumbnail-gallery">
              {allImages.map((img, index) => (
                <div
                  key={index}
                  className={`thumbnail ${selectedImage === img ? 'active' : ''}`}
                  onClick={() => setSelectedImage(img)}
                >
                  <img src={img} alt={`${product.name} ${index + 1}`} />
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="product-info">
          <h1>{product.name}</h1>
          
          {product.collection && (
            <Link 
              to={`/products?collection=${product.collection.id}`}
              className="collection-badge"
            >
              {product.collection.name}
            </Link>
          )}

          <div className="product-price-section">
            <span className="price">${parseFloat(product.price).toFixed(2)}</span>
            {product.stock > 0 ? (
              <span className="stock in-stock">In Stock ({product.stock} available)</span>
            ) : (
              <span className="stock out-of-stock">Out of Stock</span>
            )}
          </div>

          {product.sku && (
            <p className="product-sku">SKU: {product.sku}</p>
          )}

          {product.description && (
            <div className="product-description">
              <h2>Description</h2>
              <p>{product.description}</p>
            </div>
          )}

          <div className="product-actions">
            <button 
              className="add-to-cart-btn"
              disabled={product.stock === 0}
            >
              {product.stock > 0 ? 'Add to Cart' : 'Out of Stock'}
            </button>
            <button className="contact-btn">
              Contact for Details
            </button>
          </div>
        </div>
      </div>

      {product.collection && (
        <div className="related-section">
          <h2>More from {product.collection.name}</h2>
          <Link 
            to={`/products?collection=${product.collection.id}`}
            className="view-collection-btn"
          >
            View Collection →
          </Link>
        </div>
      )}
    </div>
  );
};

export default ProductDetail;
